import { render, staticRenderFns } from "./CashbackDiagram.vue?vue&type=template&id=f2036196&"
import script from "./CashbackDiagram.vue?vue&type=script&lang=js&"
export * from "./CashbackDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports